import React from 'react';
import { View } from 'react-native';
import Text from './CustomTextComponent';
import {THEME_COLORS} from '../themes';

interface IStatusComponentInterface{
    statusData:any;
    type_of_six?:string;
    fontSize?:string;
}

export const StatusComponent=(props:IStatusComponentInterface)=>{
    const statusData = props.statusData && props.statusData.length ? props.statusData : [];
    const type_of_six = props.type_of_six ?? "three_six";
    const fontSize = props.fontSize ?? "small";

    return (
        <View>
            {statusData.length ? statusData.map((item,index) => {
                return (
                    <Text key={index.toString()} type_of_six={type_of_six} fontSize={fontSize} style={{color:item.color ?? THEME_COLORS.black2,marginTop:5}}>{item.label ?? "--"}</Text>
                )
            }) : <Text fontSize={fontSize} type_of_six={type_of_six}>--</Text>}
        </View>
    )
}